import { useMemo } from 'react';
import { useReduxTanStackSync } from 'src/new_arch/providers/ReduxTanStackSyncProvider';
import { useApi } from '../../../providers/ApiProvider'
import GuestHashSystem from './GuestHashSystem';

const useGuestHashSystem = () => {
	const api = useApi();
	const sync = useReduxTanStackSync();

	return useMemo( () => new GuestHashSystem( { api, sync } ), [ api, sync ] );
}

export default useGuestHashSystem;
